export const LANGUAGES = [
    { name: 'English', code: 'en' },
    { name: 'Hindi', code: 'hi' },
    { name: 'Bahasa Indonesia', code: 'id' },
    { name: 'Spanish', code: 'es' },
    { name: 'Portugues', code: 'pt' },
    { name: 'Vietnamese', code: 'vi' },
];

export const getSituationField = (code) => `${code}Situation`;
export const getBattleQuestionField = (code) => `${code}Question`;